import { FormV3InvalidField, FormV3 } from '@bepatient/common';
import { Action } from '@ngrx/store';

export enum MyFormActionTypes {
  LOAD_FORM = '[MyFormAction] Load form',
  LOAD_FORM_FAILED = '[MyFormAction] Load form failed',
  LOAD_FORM_SUCCESS = '[MyFormAction] Load form success',
  PREV_PAGE = '[MyFormAction] Prev page',
  NEXT_PAGE = '[MyFormAction] Next page',
  SAVE_CURRENT_PAGE = '[MyFormAction] Save current page',
  SAVE_CURRENT_PAGE_FAILED = '[MyFormAction] Save current page failed',
  SAVE_CURRENT_PAGE_SUCCESS = '[MyFormAction] Save current page success',
  FORM_COMPLETED = '[MyFormAction] Form completed',
  RESET_FORM = '[MyFormAction] Reset form',
  SET_FORM_UUID = '[MyFormAction] Set form UUID',
  SET_FORM_INVALID_FIELDS = '[MyFormAction] Set form invalid fields',
  SET_FORM_SKIP_PAGE = '[MyFormAction] Set form skip page',
  SET_NEW_INPUT_ADDED = '[MyFormAction] Set form new input added'
}

export class MyFormActionLoadForm implements Action {
  readonly type = MyFormActionTypes.LOAD_FORM;
}

export class MyFormActionInputChangeOrAdd implements Action {
  readonly type = MyFormActionTypes.SET_NEW_INPUT_ADDED;
  constructor(public payload: boolean) {}
}

export class MyFormActionLoadFormFailed implements Action {
  readonly type = MyFormActionTypes.LOAD_FORM_FAILED;
}

export class MyFormActionLoadFormSuccess implements Action {
  readonly type = MyFormActionTypes.LOAD_FORM_SUCCESS;

  constructor(public payload: FormV3) {}
}

export class MyFormActionPrevPage implements Action {
  readonly type = MyFormActionTypes.PREV_PAGE;
}

export class MyFormActionNextPage implements Action {
  readonly type = MyFormActionTypes.NEXT_PAGE;
}

export class MyFormActionSaveCurrentPage implements Action {
  readonly type = MyFormActionTypes.SAVE_CURRENT_PAGE;
}

export class MyFormActionSaveCurrentPageFailed implements Action {
  readonly type = MyFormActionTypes.SAVE_CURRENT_PAGE_FAILED;
}

export class MyFormActionSaveCurrentPageSuccess implements Action {
  readonly type = MyFormActionTypes.SAVE_CURRENT_PAGE_SUCCESS;
}

export class MyFormActionFormCompleted implements Action {
  readonly type = MyFormActionTypes.FORM_COMPLETED;

  constructor(public payload: { uuid: string; occurrence: number }) {}
}

export class MyFormActionResetForm implements Action {
  readonly type = MyFormActionTypes.RESET_FORM;
}

export class MyFormActionSetFormUUID implements Action {
  readonly type = MyFormActionTypes.SET_FORM_UUID;

  constructor(
    public payload: { formUuid: string; selectedActivity?: string }
  ) {}
}

export class MyFormActionSetFormInvalidFields implements Action {
  readonly type = MyFormActionTypes.SET_FORM_INVALID_FIELDS;

  constructor(public payload: FormV3InvalidField[]) {}
}

export class MyFormActionSetFormSkipPage implements Action {
  readonly type = MyFormActionTypes.SET_FORM_SKIP_PAGE;

  constructor(public payload: any) {}
}

export type MyFormActions =
  | MyFormActionLoadForm
  | MyFormActionInputChangeOrAdd
  | MyFormActionLoadFormFailed
  | MyFormActionLoadFormSuccess
  | MyFormActionPrevPage
  | MyFormActionNextPage
  | MyFormActionSaveCurrentPage
  | MyFormActionSaveCurrentPageFailed
  | MyFormActionSaveCurrentPageSuccess
  | MyFormActionFormCompleted
  | MyFormActionResetForm
  | MyFormActionSetFormUUID
  | MyFormActionSetFormInvalidFields
  | MyFormActionSetFormSkipPage;
